module.exports = __webpack_public_path__ + "img/stop_and_collect_profiling.e8d28a4f.png";